import axios from '../../config/axiosConfig';
import {
  GET_PURCHASE_PAID_BILL_REPORT_REQUEST,
  GET_PURCHASE_PAID_BILL_REPORT_SUCCESS,
  GET_PURCHASE_PAID_BILL_REPORT_FAILURE,
  SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST,
  SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_BILLS,
  SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST,
  SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BILLS,
  SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST,
  RESET_PURCHASE_PAID_REPORT
} from '../types/purchase-paid-bill-report-types';

export const getPurchasePaidBillReport = (params) => {
  return async (dispatch, getState) => {
      try {
          dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST });

          const { auth } = getState();
          const defaultParams = {
            finyearId: auth.finyear?.id,
            companyId: auth.company?.id,
            customerId: auth.user?.Customer_Id,
          };

          const requestParams = { ...defaultParams, ...params };

          return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
            console.log('API Response Data: ', response);
            // Dispatch success action with data
            if (response.data) {
              dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_SUCCESS, payload: response.data });
            }
            return response;
          }).catch((error) => {
            console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
            dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
          });          
      } catch (error) {
          console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
          dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
      }
  };
};

export const getPurchasePartyWisePartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        showPartyList: true
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
        if(response.data) {
          dispatch({ type: SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
    }
  }
}

export const getPurchasePartyWiseBills = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_BILLS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
    }
  }
}

export const getPurchaseBrokerWiseBills = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BILLS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
    }
  }
}

export const getPurchaseBrokerWiseBrokerList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
    }
  }
}

export const getPurchaseBrokerWisePartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_REQUEST } );
      
      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const requestParams = { ...defaultParams, ...params };

      return axios.post('/paid-bill-report/getPurchasePaidBillReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
        dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching GET_PURCHASE_PAID_BILL_REPORT_FAILURE:", error);
      dispatch({ type: GET_PURCHASE_PAID_BILL_REPORT_FAILURE, error: error.message });
    }
  }
}

export const clearPurchasePaidBillReport = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_PURCHASE_PAID_REPORT });
  }
}